<template>
  <b-button
    :variant="variant"
    size="md"
    :pill="pill"
    class="button-icon"
    :style="buttonStyle"
    :disabled="disabled"
    @click="$emit('click')"
  >
    <i :class="`icon-${icon}`" :style="iconStyle"></i>
  </b-button>
</template>

<script>
export default {
  props: {
    icon: {
      type: String,
      default: '',
    },
    variant: {
      type: String,
      default: 'primary',
    },
    size: {
      type: Number,
      default: 54,
    },
    width: {
      type: Number,
      default: 0,
    },
    height: {
      type: Number,
      default: 0,
    },
    fontSize: {
      type: Number,
      default: 24,
    },
    borderSize: {
      type: Number,
      default: 0,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    pill: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    buttonStyle() {
      return {
        width: (this.width || this.size) - this.borderSize * 2 + 'px',
        height: (this.height || this.size) - this.borderSize * 2 + 'px',
        border: `${this.borderSize}px solid #FFF`,
      };
    },
    iconStyle() {
      return {
        fontSize: this.fontSize + 'px',
        lineHeight: '2rem',
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.button-icon {
  text-align: center;
  padding: 0;
  position: relative;
  i {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}
</style>
